// import React, { useEffect, useRef, useState } from "react";
// import ReactDOM from "react-dom";

// const PortalComponent = ({ parentRef, children, mode, margin, parentPosition }) => {
//   const [positionStyles, setPositionStyles] = useState({});
//   const portalRef = useRef(null);

//   const updatePosition = () => {
//     if (parentPosition && portalRef.current) {
//           const parentRect = parentRef.current.getBoundingClientRect();
//           const viewportWidth = window.innerWidth;
//           const viewportHeight = window.innerHeight;
//           const portalWidth = portalRef.current.children[0].offsetWidth;
//           const portalHeight = portalRef.current.children[0].offsetHeight;

//           let styles = {};

//           if (mode === "horizontal") {
//               // Default: Open to the right
//               styles.left = parentRect.right + margin;
//               styles.top = parentRect.top;

//                 console.log("parentRef 00",parentRect.right, portalRef.current.children[0].offsetWidth, viewportWidth);

//             // If there's not enough space on the right, switch to the left
//             if (styles.left + portalWidth > viewportWidth) {
//               styles.left = parentRect.left - portalWidth - margin; // Switch to left
//             }

//             // Ensure the portal fits within the vertical bounds
//             if (styles.top + portalHeight > viewportHeight) {
//               styles.top = viewportHeight - portalHeight; // Adjust to fit at the bottom
//             } else if (styles.top < 0) {
//               styles.top = 0; // Adjust to fit at the top
//             }
//           } else if (mode === "vertical") {
//             console.log("parentRef 00 ver",parentRect.left, parentRect, portalRef.current.children[0].offsetWidth, viewportWidth);
//             // Default: Open to the bottom
//             styles.top = parentRect.bottom + margin;
//             styles.left = parentRect.left;

//             // If there's not enough space below, switch to the top
//             if (styles.top + portalHeight > viewportHeight) {
//               styles.top = parentRect.top - portalHeight - margin; // Switch to top
//             }

//             // Ensure the portal fits within the horizontal bounds
//             if (styles.left + portalWidth > viewportWidth) {
//               styles.left = viewportWidth - portalWidth; // Adjust to fit at the right
//             } else if (styles.left < 0) {
//               styles.left = 0; // Adjust to fit at the left
//             }
//           }

//           setPositionStyles({
//             ...styles,
//             position: "fixed",
//             zIndex: 1000,
//           });
//         }
//   }
//   useEffect(() => {
//       updatePosition()

//         window.addEventListener("resize", updatePosition);
//         window.addEventListener("scroll", updatePosition, true); // Update position on scroll
//         // window.addEventListener("mousedown", handleOutsideClick);
//       return () => {
//         window.removeEventListener("resize", updatePosition);
//         window.removeEventListener("scroll", updatePosition, true);
//         // window.removeEventListener("mousedown", handleOutsideClick);
//       };
//   }, [parentPosition, parentPosition?.top]);

//   return ReactDOM.createPortal(
//     <div
//       ref={portalRef}
//       style={{
//         ...positionStyles,
//         // background: "white",
//         // border: "1px solid #ccc",
//         // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//         // borderRadius: "8px",
//         // padding: "16px",
//       }}
//     >
//       {children}
//     </div>,
//     document.body
//   );
// };

// const FloatingList = ({ children, mode = "horizontal", margin = 5 }) => {
//   const parentRef = useRef(null);

//   const [parentRect, setParentRect] = useState(null);
//   useEffect(() => {
//     if(parentRef.current){
//       const rect = parentRef.current.getBoundingClientRect();
//       setParentRect(rect);
//     }
//   },[parentRef?.current?.style.top])

//   return (
//     <div ref={parentRef} className="floating-component" style={{ display: "inline-block", position: "relative" }}>
//       <PortalComponent  parentRef={parentRef} mode={mode} margin={margin} parentPosition={parentRect}>
//         {children}
//       </PortalComponent>
//     </div>
//   );
// };

// export default FloatingList;

import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

const FloatingElement = ({
  children,
  mode = "horizontal",
  margin = 10,
  xMargin = 0,
  yMargin = 0,
  zIndex = 1000,
  anchorParentRef = null,
  isParentHight,
  xPadding = 0,
}) => {
  console.log("anchorParentRef", anchorParentRef);
  const parentRef = useRef(null);
  const listRef = useRef(null);
  const [positionStyles, setPositionStyles] = useState({});
  const [parentHight, setParentHeight] = useState(0);

  /**
   * Function to update the position of the floating list dynamically.
   */
  const updatePosition = () => {
    if (parentRef.current && listRef.current) {
      //   const parentRect = parentRef.current.getBoundingClientRect();
      const parentRect = Boolean(anchorParentRef?.current)
        ? anchorParentRef?.current.parentElement?.getBoundingClientRect()
        : parentRef.current.parentElement.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const listWidth = listRef.current.offsetWidth;
      const listHeight = listRef.current.offsetHeight;

      setParentHeight(parentRect.height);

      let styles = {};
      if (mode === "horizontal") {
        console.log("parentRef 00 render", parentRect.right, margin);
        // Default: Open to the right
        styles.left = parentRect.right + margin + xMargin;
        styles.top = parentRect.top + yMargin;

        // If there's not enough space on the right, switch to the left
        if (styles.left + listWidth > viewportWidth) {
          styles.left = parentRect.left - listWidth - margin - xMargin; // Switch to left
        }

        // Ensure the list fits within the vertical bounds
        if (styles.top + listHeight > viewportHeight) {
          styles.top = viewportHeight - listHeight + yMargin; // Adjust to fit at the bottom
        } else if (styles.top < 0) {
          styles.top = 0; // Adjust to fit at the top
        }
      } else if (mode === "vertical") {
        // Default: Open to the bottom
        styles.top = parentRect.bottom + margin + yMargin;
        styles.left = parentRect.left + xMargin;

        // If there's not enough space below, switch to the top
        if (styles.top + listHeight > viewportHeight) {
          styles.top = parentRect.top - listHeight - margin - yMargin; // Switch to top
        }

        // Ensure the list fits within the horizontal bounds
        if (styles.left + listWidth > viewportWidth) {
          styles.left = viewportWidth - listWidth; // Adjust to fit at the right
        } else if (styles.left < 0) {
          styles.left = 0; // Adjust to fit at the left
        }
      }

      setPositionStyles(styles);
    }
  };

  /**
   * Attach event listeners for dynamic positioning.
   */
  useLayoutEffect(() => {
    updatePosition();

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true); // Update position on scroll

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, []);

  return (
    <div ref={parentRef} style={{ position: "relative" }}>
      {/* Floating List */}
      <div
        ref={listRef}
        style={{
          position: "fixed",
          height: isParentHight && parentHight,
          ...positionStyles,
          zIndex: zIndex,
          padding: `0 ${xPadding}px`,
          //   background: "white",
          //   border: "1px solid #ccc",
          //   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          //   borderRadius: "8px",
          //   padding: "16px",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default FloatingElement;
